module.exports = __webpack_public_path__ + "static/media/ga.096f551d.svg";